import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Keys, Labels } from '../gasflow.constants';
import { UnitsService,Quantity } from 'pumpcalc-core';
import {GasflowBoundaryConditions,GasFlowBoundaryConditionsType } from '../gasflow-solver.service';

@Component({
  selector: 'app-boundary-condition-form',
  templateUrl: './boundary-condition-form.component.html',
  styleUrls: ['./boundary-condition-form.component.css']
})
export class BoundaryConditionFormComponent implements OnInit {

  conditions:any[]=[];
  @Output() conditionChanged:EventEmitter<{conditions:any[],gasflowBoundaryConditions:GasflowBoundaryConditions}> = new EventEmitter();
  @Input() errors={};
  keys=Keys;
  labels=Labels;
  quantity=Quantity;
  throughPutQuantity=Quantity.THROUGHPUT;

  setUpstreamPressureandDownstreamPressure = "Set Upstream Pressure and Downstream Pressure";
  setUpstreamPressureandThroughput = "Set Upstream Pressure and Throughput";
  setUpstreamPressureandDownstreamSpeed = "Set Upstream Pressure and Downstream Speed";
  setDownstreamPressureandDownstreamSpeed = "Set Downstream Pressure and Downstream Speed";
  setDownstreamPressureandThroughput = "Set Downstream Pressure and Throughput";

  options=[
  this.setUpstreamPressureandDownstreamPressure,
  this.setUpstreamPressureandThroughput,
  this.setUpstreamPressureandDownstreamSpeed,
  this.setDownstreamPressureandDownstreamSpeed,
  this.setDownstreamPressureandThroughput
  ];

  option = this.setUpstreamPressureandDownstreamPressure;

  inlet=false;
  upstreamPressure=0
  downstreamPressure=0;
  throughput=0;
  downstreamSpeed=0;
  inletDiameter=0;

  showInletDiameter=false;

  constructor(public unitsService:UnitsService) { }

  ngOnInit() {
    this.valueChanged();
  }

  diameterForSpeed(){
    return "(?)"
  }

  valueChanged(){

    this.conditions =[];


    Object.keys(this.conditions).forEach(function(key) { delete this.conditions[key]; }.bind(this));
    let gasflowBoundaryConditions:GasflowBoundaryConditions = new GasflowBoundaryConditions();

    if(this.option == this.setUpstreamPressureandDownstreamPressure){
      this.conditions[Keys.systemDownstreamPressure] = {value:this.downstreamPressure,input:true,quantity:Quantity.PRESSURE};
      this.conditions[Keys.systemUpstreamPressure] = {value:this.upstreamPressure,input:true, quantity:Quantity.PRESSURE};
      gasflowBoundaryConditions.Type = GasFlowBoundaryConditionsType.PuPd;
      gasflowBoundaryConditions.BoundaryCondition1 = this.conditions[Keys.systemUpstreamPressure].value;
      gasflowBoundaryConditions.BoundaryCondition2 = this.conditions[Keys.systemDownstreamPressure].value;
    }

    if(this.option == this.setDownstreamPressureandDownstreamSpeed){
      this.conditions[Keys.systemDownstreamPressure] = {value:this.downstreamPressure,input:true,quantity:Quantity.PRESSURE};
      this.conditions[Keys.systemDownstreamSpeed] = {value:this.downstreamSpeed,input:true,quantity:Quantity.SPEED};
      if(this.showInletDiameter){this.conditions[Keys.inletDiameter] = {value:this.inletDiameter,input:true,quantity:Quantity.XDIM}};
      gasflowBoundaryConditions.Type = GasFlowBoundaryConditionsType.PdS;
      gasflowBoundaryConditions.BoundaryCondition1 = this.conditions[Keys.systemDownstreamPressure].value;
      gasflowBoundaryConditions.BoundaryCondition2 = this.conditions[Keys.systemDownstreamSpeed].value;
    }

    if(this.option == this.setUpstreamPressureandThroughput) {
      this.conditions[Keys.systemUpstreamPressure] = {value:this.upstreamPressure,input:true,quantity:Quantity.PRESSURE};
      this.conditions[Keys.systemThroughput] = {value:this.throughput,input:true,quantity:this.throughPutQuantity};
      gasflowBoundaryConditions.Type = this.boundaryTypeForThroughPutQuantity(this.throughPutQuantity,GasFlowBoundaryConditionsType.PuQ);
      gasflowBoundaryConditions.BoundaryCondition1 = this.conditions[Keys.systemUpstreamPressure].value;
      gasflowBoundaryConditions.BoundaryCondition2 = this.conditions[Keys.systemThroughput].value;
    }

    if(this.option == this.setUpstreamPressureandDownstreamSpeed) {
      this.conditions[Keys.systemUpstreamPressure] = {value:this.upstreamPressure,input:true, quantity:Quantity.PRESSURE};
      this.conditions[Keys.systemDownstreamSpeed] = {value:this.downstreamSpeed,input:true,quantity:Quantity.SPEED};
      gasflowBoundaryConditions.Type = GasFlowBoundaryConditionsType.PuS
      gasflowBoundaryConditions.BoundaryCondition1 = this.conditions[Keys.systemUpstreamPressure].value;
      gasflowBoundaryConditions.BoundaryCondition2 = this.conditions[Keys.systemDownstreamSpeed].value;
    }

    if(this.option == this.setDownstreamPressureandThroughput) {
      this.conditions[Keys.systemDownstreamPressure] = {value:this.downstreamPressure,input:true,quantity:Quantity.PRESSURE};
      this.conditions[Keys.systemThroughput] = {value:this.throughput,input:true,quantity:this.throughPutQuantity};
      gasflowBoundaryConditions.Type = this.boundaryTypeForThroughPutQuantity(this.throughPutQuantity,GasFlowBoundaryConditionsType.PdQ);
      gasflowBoundaryConditions.BoundaryCondition1 = this.conditions[Keys.systemDownstreamPressure].value;
      gasflowBoundaryConditions.BoundaryCondition2 = this.conditions[Keys.systemThroughput].value;
    }

    this.conditionChanged.emit({conditions:this.conditions,gasflowBoundaryConditions:gasflowBoundaryConditions});

  }

  throughPutQuantityChange(change){
    this.throughPutQuantity=change.quantity;
    this.valueChanged();
  }

  boundaryTypeForThroughPutQuantity(quantity,boundaryType:GasFlowBoundaryConditionsType):GasFlowBoundaryConditionsType{
    switch(quantity){
      case Quantity.THROUGHPUT : return boundaryType;
      case Quantity.THROUGHPUT_MASS_FLOW : return GasFlowBoundaryConditionsType[boundaryType+"mass"];
      case Quantity.THROUGHPUT_MOLAR_FLOW : return GasFlowBoundaryConditionsType[boundaryType+"mol"];
    }
  }
}
